module.exports = __webpack_public_path__ + "img/kyc-view.3f4e0aea.svg";